import React from 'react';
import { View, Text } from 'react-native';
import { Icon } from '@qnpm/q-theme';
import TipsStyle from './style';
const TipStyle = new TipsStyle(false);
const getCardProps = (leftIcon, customStyle, title, rightText, props) => {
    TipStyle.setIsScale(props.needScale);
    let styles = TipStyle.getStyle();
    const icon = (<View style={styles.cardLeftIcon}>
            <Icon name={leftIcon} size={18} needScale={props.needScale} color={customStyle === null || customStyle === void 0 ? void 0 : customStyle.brandColor} style={styles.cardLeftIconStyle}/>
            <Text style={[
        styles.cardLeftIconText,
        { color: customStyle.brandColor }
    ]}>
                {title}
            </Text>
        </View>);
    return Object.assign(Object.assign({}, props), { leftIcon: icon, customStyle, layoutType: 2 });
};
const getStandardProps = (leftIcon, customStyle, title, rightText, props) => {
    return Object.assign(Object.assign({}, props), { rightText,
        title,
        customStyle,
        leftIcon });
};
const getBackgroundTitle = (leftIcon, customStyle, title, rightText, props) => {
    TipStyle.setIsScale(props.needScale);
    let styles = TipStyle.getStyle();
    const icon = (<View style={[
        styles.iconTitle,
        { backgroundColor: customStyle.brandColor }
    ]}>
            <Text style={styles.iconTitleText}>{title}</Text>
        </View>);
    return Object.assign(Object.assign({}, props), { rightText, leftIcon: icon, customStyle });
};
const getCenterProps = (leftIcon, customStyle, title, rightText, props) => {
    return Object.assign(Object.assign({}, props), { title,
        rightText,
        customStyle,
        leftIcon, layoutType: 3 });
};
const getRightTextProps = (leftIcon, customStyle, title, rightText, props) => {
    TipStyle.setIsScale(props.needScale);
    let styles = TipStyle.getStyle();
    const icon = (<>
            <Text style={[
        styles.rightTextStyle,
        { color: customStyle.textColor }
    ]}>
                {rightText}
            </Text>
            <Icon name="chevronForward" size={12} style={styles.rightTextIcon} color={customStyle.textColor}/>
        </>);
    return Object.assign(Object.assign({}, props), { leftIcon,
        customStyle,
        title, rightIcon: icon });
};
const getRightButtonProps = (leftIcon, customStyle, title, rightText, props) => {
    TipStyle.setIsScale(props.needScale);
    let styles = TipStyle.getStyle();
    let icon = (<View style={[
        styles.ButtonContainer,
        { borderColor: customStyle.textColor }
    ]}>
            <Text style={[styles.ButtonText, { color: customStyle.textColor }]}>
                {rightText}
            </Text>
        </View>);
    return Object.assign(Object.assign({}, props), { leftIcon,
        customStyle,
        title, rightIcon: icon });
};
const getMoreOperationArea = (leftIcon, customStyle, title, rightText, props) => {
    TipStyle.setIsScale(props.needScale);
    let styles = TipStyle.getStyle();
    let icon = (<View style={[
        styles.moreOperationAreaButton,
        { borderColor: customStyle.textColor }
    ]}>
            <Text style={[styles.ButtonText, { color: customStyle.textColor }]}>
                {rightText}
            </Text>
        </View>);
    return Object.assign(Object.assign({}, props), { leftIcon,
        customStyle,
        title, rightIconType: 'merge', rightIcon: icon });
};
const PROPS_FORMATE_MAPPING = {
    0: getCardProps,
    1: getStandardProps,
    2: getCenterProps,
    3: getRightTextProps,
    4: getRightButtonProps,
    5: getBackgroundTitle,
    6: getMoreOperationArea
};
export default PROPS_FORMATE_MAPPING;
